export const getShopUrl = () => (window as any).Pura?.shop_domain || 'pura.com'

export const getShopMyShopifyUrl = () =>
  (window as any).Pura?.shop_myshopify_url || 'pura-scents.myshopify.com'
